import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

// Contexts
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { WebSocketProvider } from './contexts/WebSocketContext';

// Pages
import LoginPage from './pages/LoginPage';
import ReportPage from './pages/ReportPage';
import ExcludedEntitiesPage from './pages/ExcludedEntitiesPage';
import MappingsPage from './pages/MappingsPage';
import BulkUserUpdatePage from './pages/BulkUserUpdatePage';

// Components
import Layout from './components/Layout';

// Protected route component
const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};

function App() {
  return (
    <AuthProvider>
      <WebSocketProvider>
        <Router>
          <Routes>
            <Route path="/login" element={<LoginPage />} />

            <Route path="/" element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }>
              <Route index element={<Navigate to="/report" replace />} />
              <Route path="report" element={<ReportPage />} />
              <Route path="excluded-entities" element={<ExcludedEntitiesPage />} />
              <Route path="mappings" element={<MappingsPage />} />
              <Route path="bulk-user-update" element={<BulkUserUpdatePage />} />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Router>
      </WebSocketProvider>
    </AuthProvider>
  );
}

export default App;
